var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoChainweaver = function SvgLogoChainweaver(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0553cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.015,
    y1: 0.5,
    x2: 0.962,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#6546b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#5f4fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#4b74c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#3b91d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#30a6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#29b2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#27b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.07,
    y1: 0.257,
    x2: 0.527,
    y2: 0.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#6546b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#5562c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#4481ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#3798d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#2ea9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#28b3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#27b7e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chainweaver",
    transform: "translate(9808.5 -4173.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5901",
    "data-name": "Ellipse 5901",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(-9808 4206.554) rotate(-90)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_964",
    "data-name": "Ellipse 964",
    cx: 15.81,
    cy: 15.81,
    r: 15.81,
    transform: "translate(-9807.31 4174.245)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70373",
    "data-name": "Group 70373",
    transform: "translate(-9828.164 3855.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42978",
    "data-name": "Path 42978",
    d: "M55.851,324H49.613l-7.342,7.7v6.418Z",
    transform: "translate(-9.998 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32692",
    "data-name": "Rectangle 32692",
    width: 5.273,
    height: 21.249,
    transform: "translate(27 324)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42979",
    "data-name": "Path 42979",
    d: "M59.862,361.364,51.2,348.614l-3.527,3.668,6.07,9.082Z",
    transform: "translate(-13.532 -16.115)",
    fill: "url(#linear-gradient-3)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoChainweaver, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-chainweaver.30d41a7c.svg";
export { ForwardRef as ReactComponent };